<dx-box width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <div class="row-container">
                Closed Invoices In Past
                <div class="add-padding">
                    <dx-number-box width="55px" [min]="1" [max]="3650" [(value)]="numberOfDays"></dx-number-box>
                </div>
                Days
                <div class="add-padding">
                    <dx-button
                        type="default"
                        text="Refresh"
                        hint="Refresh"
                        [icon]="iconRefresh"
                        (onClick)="onForceReload()"
                    ></dx-button>
                </div>
            </div>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-manage-invoice-grid
                workOrderStatus="open"
                [invoiceIds]="invoiceIds"
                [communityId]="communityId"
                [invoiceGridSource]="closedInvoices"
                (onRowSelectionChange)="onInvoiceSelectionChange($event)"
            ></app-manage-invoice-grid>
        </div>
    </dxi-item>
</dx-box>
